<template>
  <section class="bg-primary">
    <div class="container ">

      <ContentsPageTitle
        title="Bio-based material"
        description="Our bio-based materials use feed stock from renewable sources instead of fossil fuels.
          Therefore, we can reduce fuel consumption and the quality of new bio-based resins is the same as virgin
          material."
      />

    </div>
  </section>

  <!-- PRODUCT DETAIL PAGE -->
  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/sustainable-plastics/bio01.jpg"
            :contents="[
              'Bioplastics has been introduced for long time but their use is limited due to its inferior properties. Today it’s possible for bio-based plastics to perform like their based resins both mechanical properties and color space. This bio-based materials use waste product from plant that is not edible, so it doesn’t damage food supply. Our solution can reduce carbon footprint up to 60% and reduce fossil depletion up to 80%. It’s available from PP to engineering plastics'
            ]"
            is-reverse="true"
            left-width="43.444%"
            right-width="56.275%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/sustainable-plastics/bio02.jpg"
            :contents="[
              'From food packaging, food contact to consumer electronics, auto parts etc..'
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :is-remove-contact-text="true"
          :partners="[
            {
              name: 'Sabic',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/sustainable-plastics/Screen-Shot-2565-05-19-at-15.08.54.png',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'Bio-based material - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>